import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, request, toast } from '../../../../../utils';

const PRODUCT_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.productDetails[0]?.product?.name
  }
];

const PRODUCT_DETAILS_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.productDetails[0]?.product?.name
  },
  {
    header: 'GRN/CR',
    accessor: (row) => row?.productDetails[0]?.cnt
  },
  {
    header: 'Bill Qty',
    accessor: (row) => row?.productDetails[0]?.total_qty
  },
  {
    header: 'Free Qty',
    accessor: (row) => row?.productDetails[0]?.free_qty
  },
  {
    header: 'Rate',
    accessor: (row) => row?.productDetails[0]?.rate
  },
  {
    header: 'Batch',
    accessor: (row) => row?.productDetails[0]?.batch_no
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.productDetails[0]?.supplier?.ledger_name
  }
];

export const StoreProductDetails = () => {
  const [productStockDetail, setProductStockDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [stock, setStock] = useState([]);
  const [stockDetails, setStockDetails] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });

  const { handleSubmit, reset, setValue } = methods;

  const getProductDetails = useCallback(async () => {
    const productData = await dropdownFetch('store-stock-master');
    const fromDate = methods.getValues('from_date');
    const toDate = methods.getValues('to_date');
    const filteredData = filterData(productData, fromDate, toDate);
    setProductStockDetails(filteredData);
  }, [methods]);

  useEffect(() => {
    getProductDetails();
  }, [methods.watch('from_date'), methods.watch('to_date'), getProductDetails]);

  const handleRowClick = (row) => {
    const filteredProducts = productStockDetail.filter((product) => product._id === row._id);
    if (filteredProducts.length > 0) {
      setProductDetails(filteredProducts);
      console.log('PRODUCTDETAILS', productDetails);
    }
  };

  const filterUniqueProducts = (consignmentData) => {
    const filteredData = consignmentData.reduce((acc, current) => {
      const x = acc.find((item) => item.batch_no === current.batch_no);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredData;
  };

  const fetchStock = async () => {
    const response = await request('/store-stock-master-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setStock({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setStock({ loading: false });
    }
  };

  useEffect(() => {
    fetchStock();
  }, []);

  const handleRowProduct = (row) => {
    if (stock.data && stock.data.length > 0) {
      const allProductDetails = stock.data.flatMap((dataItem) => dataItem.productDetails || []);
      const matchingProducts = allProductDetails.filter((product) => product.product === row.product);
      if (matchingProducts.length > 0) {
        setStockDetails(matchingProducts);
        console.log('Matching Stock Details', matchingProducts);
      } else {
        setStockDetails([]);
      }
    } else {
      setStockDetails([]);
    }
  };

  const filterData = (data, fromDate, toDate) => {
    let filteredData = [...data];
    if (fromDate && toDate) {
      const from = new Date(fromDate).setHours(0, 0, 0, 0);
      const to = new Date(toDate).setHours(23, 59, 59, 999);
      filteredData = filteredData.filter((item) => {
        const createdAt = new Date(item.createdAt).getTime();
        return createdAt >= from && createdAt <= to;
      });
    }
    return filteredData;
  };

  useEffect(() => {
    if (productDetails && productDetails.length > 0) {
      const products = productDetails[0]?.productDetails || [];
      const total = products.reduce((acc, product) => {
        return acc + (product.total_qty || 0) + (product.free_qty || 0);
      }, 0);
      setTotalQuantity(total);
    } else {
      setTotalQuantity(0);
    }
  }, [productDetails]);

  useEffect(() => {
    console.log('HELLLLO PRODUCT STOCK DETAILS', productStockDetail);
  }, [productStockDetail]);
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700, fontSize: '1.4rem' }}>
                Product Details
              </Typography>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Stack spacing={2} direction="row" alignItems="center" marginLeft={'2%'} marginTop={'1%'}>
                  <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.5 }} name="from_date" type="date" />
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.5 }} name="to_date" type="date" />
                </Stack>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: 'flex', flexDirection: 'column', marginLeft: '0.2%', marginTop: '1%' }}
                  >
                    <Table
                      containerSX={{
                        flex: 1,
                        border: '0px solid rgba(0,0,0,0.27)',
                        maxHeight: '500px'
                      }}
                      data={productStockDetail || []}
                      columns={PRODUCT_HEADER}
                      size="large"
                      onRowClick={handleRowClick}
                      sx={{
                        '& .MuiTableCell-root': {
                          fontSize: '1.4rem'
                        },

                        '& .MuiTableCell-head': {
                          fontSize: '1.4rem'
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={7.8} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography color="primary" variant="h6" sx={{ fontWeight: 700, fontSize: '1.4rem' }}>
                      Current Stock :- {totalQuantity}
                    </Typography>
                    <Table
                      containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                      data={filterUniqueProducts(productDetails) || []}
                      columns={PRODUCT_DETAILS_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        handleRowProduct(row);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
